export const environment = {
  production: true,
  appName: 'Axtron',
  apiUrl: 'https://api.preview.axtron.info/v1',
  apiLanguage: 'de-CH',
};
